import EducationModel from '../model/EducationModel'
import TextControl from '../../../lib/ui/TextControl'
import PickerControl from '../../../lib/ui/PickerControl'
import SelectPerson from '../../person/action/SelectPerson'
import SelectLocation from '../../location/action/SelectLocation'
import DateControl from '../../../lib/ui/DateControl'

export default class EducationForm {
  constructor (element, args) {
    let fieldsetEducation = document.createElement('fieldset')
    let legendEducation = document.createElement('legend')
    legendEducation.innerHTML = 'Opleiding'
    fieldsetEducation.appendChild(legendEducation)
    let popup = null

    this.id = args.education.values.id
    this.person = new PickerControl(fieldsetEducation, {label: 'Persoon', value: args.education.values.person_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectPerson(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.person.setValue(item.values.id, item)
            } else {
              this.person.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.person.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.location = new PickerControl(fieldsetEducation, {label: 'Locatie', value: args.education.values.location_id,
      onchange: args.onchange,
      onselect: (item) => {
        if (item.values.id) {
          window.PRIM.navigate('/locations/' + item.values.id)
        }
      },
      onclick: () => {
        let popupElement = document.getElementById('popup')
        let viewportElement = document.getElementById('viewport')

        popup = new SelectLocation(popupElement, {
          onok: (item) => {
            if (item && item.values.id) {
              this.location.setValue(item.values.id, item)
            } else {
              this.location.setValue(null, null)
            }

            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
            this.location.onchange()
          },
          oncancel: () => {
            viewportElement.classList.remove('invisible')
            popupElement.classList.add('invisible')
            popupElement.innerHTML = ''
          }
        })
        viewportElement.classList.add('invisible')
        popupElement.classList.remove('invisible')
      }
    })
    this.title = new TextControl(fieldsetEducation, {label: 'Titel', value: args.education.values.title, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange})
    this.start = new DateControl(fieldsetEducation, {label: 'Start', value: args.education.values.start, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange})
    this.end = new DateControl(fieldsetEducation, {label: 'Einde', value: args.education.values.end, readonly: window.PRIM.hasReadonlyModuleAccess('educations'), onchange: args.onchange})

    let fragment = document.createDocumentFragment()
    fragment.appendChild(fieldsetEducation)

    element.appendChild(fragment)
  }

  getValue () {
    let education = new EducationModel()
    education.person = this.person.getItem()
    education.location = this.location.getItem()
    education.values.id = this.id
    education.values.location_id = this.education.getValue()
    education.values.title = this.title.getValue()
    education.values.start = this.start.getValue()
    education.values.end = this.end.getValue()
    return education
  }

  setValue (education) {
    this.id = education.values.id
    this.person.setValue(education.values.person_id, education.person)
    this.location.setValue(education.values.location_id, education.location)
    this.title.setValue(education.values.title)
    this.start.setValue(education.values.start)
    this.end.setValue(education.values.end)
  }
}



// WEBPACK FOOTER //
// ./js/modules/education/ui/EducationForm.js